module.exports = __webpack_public_path__ + "img/ic_fluent_copy_20_regular.71767cb8.svg";